














import Proxyable from '@/mixins/proxyable';
import { IRequisition, IUser } from '@/models';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Proxyable.extend({
  name: 'RequisitionApproverPicker',

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    },
    externalErrorMessage: {
      type: String,
      default: () => ''
    },
    approvers: {
      type: Array as PropType<IUser[]>,
      default: () => []
    }
  },

  data: () => ({
    loading: false,
    errorMessage: ''
  }),

  computed: {
    ...mapGetters({
      fetchedApprovers: 'requisition/getRequisitionApprovers'
    }),

    approverList(): IUser[] {
      return this.approvers.length ? this.approvers : this.fetchedApprovers;
    },

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.errorMessage = '';
  },

  methods: {
    ...mapActions({
      fetchRequisitionApprovers: 'requisition/fetchRequisitionApprovers'
    }),

    init() {
      if (!this.approvers.length) {
        this.loading = true;
        this.fetchRequisitionApprovers(this.requisition.id)
          .catch(() => {
            this.errorMessage = 'Error getting approvers';
          })
          .finally(() => (this.loading = false));
      }
    }
  }
});
